<template>
  <v-dialog width="600" class="mt-n8" v-model="dialog">
    <v-card>
      <v-text-field
        ref="refTextBox"
        v-model="textToSearch"
        prepend-inner-icon="mdi-magnify"
        color="grey"
        filled
        placeholder="Looking for..."
      >
        <template v-slot:append>
          <v-btn
            outlined
            class="mt-n1"
            size="small"
            color="grey"
            @click="dialog = false"
          >
            Esc
          </v-btn>
        </template>
      </v-text-field>

      <v-card-text class="mt-n8">
        <template v-if="!prodottiFiltrati.length">
          <v-row justify="center" class="mt-8">
            <v-icon size="100" color="grey"
              >mdi-clipboard-text-search-outline</v-icon
            >
          </v-row>
          <v-row justify="center" class="mt-4">
            <span class="text-grey">I risultati appariranno qua</span>
          </v-row>
        </template>
        <template v-else>
          <v-card
            flat
            outlined
            v-for="diametro in prodottiPerDiametro"
            :key="diametro.diametro"
            class="my-4"
          >
            <v-card-title>
              <span style="font-size: 15px"
                >Vaso Ø {{ diametro.diametro }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-list class="mt-n4 ml-n4">
                <NuovoProdottoRicerca
                  v-for="prodotto in diametro.elementi"
                  :key="prodotto.id"
                  :prodotto="prodotto"
                  @selezionato="setCurrentProduct"
                />
              </v-list>
            </v-card-text>
          </v-card>
        </template>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NuovoProdottoRicerca from "./NuovoProdottoRicerca.vue";
export default {
  components: {
    NuovoProdottoRicerca,
  },
  data() {
    return {
      dialog: false,
      textToSearch: "",
      prodotti: [],
      prodottiFiltrati: [],
      currentProduct: null,
    };
  },
  watch: {
    textToSearch(newVal) {
      if (newVal.length >= 3) {
        this.cercaProdotti(newVal);
      } else {
        this.prodottiFiltrati = [];
      }
    },
  },
  computed: {
    prodottiPerDiametro() {
      const prodottiPerDiametro = {};

      this.prodottiFiltrati.forEach((prodotto) => {
        const diametro = prodotto.diametro;
        if (!prodottiPerDiametro[diametro]) {
          prodottiPerDiametro[diametro] = [];
        }
        prodottiPerDiametro[diametro].push(prodotto);
      });

      return Object.keys(prodottiPerDiametro).map((diametro) => ({
        diametro: parseInt(diametro),
        elementi: prodottiPerDiametro[diametro],
      }));
    },
  },
  methods: {
    open() {
      this.dialog = true;
      setTimeout(() => {
        this.$refs.refTextBox.focus();
      }, 100);
    },
    close() {
      this.dialog = false;
    },
    cercaProdotti() {
      this.prodottiFiltrati = this.$store.getters.get_lista_prodotti_raw.filter(
        (prodotto) =>
          prodotto.nome.toLowerCase().includes(this.textToSearch.toLowerCase())
      );
    },
    setCurrentProduct(id) {
      this.$emit("selezionato", id);
      this.textToSearch = "";
      this.dialog = false;
    },
  },
};
</script>